import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { MergeOrganizationParameters } from '../../components/admin/organization/advancedEditing/MergeOrganizationsForm';
import { IntakeAction, IntakeActionType } from '../actions/IntakeActions';
import { Intake } from '../types';

export const getAllAdminIntakes =
    () => async (dispatch: Dispatch<IntakeAction>) => {
        const response = await SuSyApi.get(`/intake/admin`);
        dispatch({
            type: IntakeActionType.GET_ALL_ADMIN_INTAKES,
            payload: response.data,
        });
    };

export const getAllIntakes = () => async (dispatch: Dispatch<IntakeAction>) => {
    const response = await SuSyApi.get(`/intake`);
    dispatch({
        type: IntakeActionType.GET_ALL_INTAKES,
        payload: response.data,
    });
};

export const getIntake =
    (intake: Intake) => async (dispatch: Dispatch<IntakeAction>) => {
        const response = await SuSyApi.get(`/intake/${intake._id}`);
        dispatch({
            type: IntakeActionType.GET_INTAKE,
            payload: response.data,
        });
    };

export const createIntake =
    (intake: Intake) => async (dispatch: Dispatch<IntakeAction>) => {
        const response = await SuSyApi.post(`/intake`, intake);
        dispatch({
            type: IntakeActionType.CREATE_INTAKES,
            payload: response.data,
        });
    };

export const updateIntake =
    (intake: Intake) => async (dispatch: Dispatch<IntakeAction>) => {
        const response = await SuSyApi.put(`/intake/${intake._id}`, intake);
        dispatch({
            type: IntakeActionType.UPDATE_INTAKES,
            payload: response.data,
        });
    };

export const deleteIntakes =
    (ids: Array<string>, transferToId: string) =>
    async (dispatch: Dispatch<IntakeAction>) => {
        const response = await SuSyApi.delete(`/intake`, {
            data: {
                ids,
                transferToId,
            },
        });
        dispatch({
            type: IntakeActionType.DELETE_INTAKES,
            payload: response.data,
        });
    };
export const mergeIntakes =
    (parameters: MergeOrganizationParameters) =>
    async (dispatch: Dispatch<IntakeAction>) => {
        const response = await SuSyApi.post(`/intake/merge`, parameters);
        dispatch({
            type: IntakeActionType.MERGE_INTAKES,
            payload: response.data,
        });
    };
